<template>
  <b-input-group class="filter-input-group" :class="{ 'no-max-width': noMaxWidth }">
    <template #prepend v-if="prependIcon">
      <b-input-group-text>
        <Icon :icon="prependIcon" />
      </b-input-group-text>
    </template>
    <b-input
      class="filter-input"
      :placeholder="placeholder"
      v-model="internValue"
      type="text"
      ref="search"
      @keyup.enter="internValue = search?.value"
      :lazy="!triggerByTime"
      data-cy="filter-txt" />
    <b-input-group-append v-if="internValue">
      <b-btn @click="clearSearch" data-cy="clear-filter-button">
        <i class="mdp-Close"></i>
      </b-btn>
    </b-input-group-append>
  </b-input-group>
</template>

<script setup lang="ts">
import { BFormInput } from "bootstrap-vue";
import { ref, watch } from "vue";
import Icon from "./Icon.vue";

const search = ref<BFormInput | null>(null);

const props = withDefaults(
  defineProps<{
    value: string | null;
    noMaxWidth?: boolean;
    prependIcon?: string;
    placeholder?: string;
    triggerTime?: number;
    triggerByTime?: boolean;
  }>(),
  { triggerTime: 500 }
);

const internValue = ref(props.value);

const emits = defineEmits(["input"]);

watch(
  () => props.value,
  (nv) => {
    internValue.value = nv;
  }
);

watch(internValue, (nv) => {
  if (props.triggerByTime) {
    triggerAfterTime(props.triggerTime);
  } else {
    emits("input", nv);
  }
});

const clearSearch = () => {
  emits("input", null);
};

const triggerAfterTime = async (timeInMS: number) => {
  setTimeout(() => {
    emits("input", internValue.value);
  }, timeInMS);
};
</script>
